// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3QMpr","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3GZXi"};